import cn from 'classnames';
import type * as React from 'react';
import styles from './RichList.module.css';

type Props = {
  /**
   * This should be an array of <li> elements
   *
   * Note, we can't be more exact for now because TS treats all jsx elements the same.
   * See https://github.com/Microsoft/TypeScript/issues/14729
   */
  children: Array<React.JSX.Element | null>;
  className?: string;
};

/**
 * Renders a list of items in a vertical list, with borders around each item.
 */
export function RichList({ children, className }: Props) {
  return <ul className={cn(styles.RichList, className)}>{children}</ul>;
}
